import Sku from './index.vue'

Sku.install = Vue => {
  Vue.component(Sku.name, Sku)
}

export default Sku



// WEBPACK FOOTER //
// ./src/components/sku/index.js